import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.613 3.21a1 1 0 0 0-1.32.083l-12 12-.087.099A1 1 0 0 0 11 16v4l.007.117A1 1 0 0 0 12 21h4l.131-.009a1 1 0 0 0 .576-.284l12-12 .083-.094a1 1 0 0 0-.083-1.32l-4-4zM18 5a1 1 0 0 0-1-1H6l-.15.005A2 2 0 0 0 4 6v20l.005.15A2 2 0 0 0 6 28h20l.15-.006A2 2 0 0 0 28 26V15l-.007-.117A1 1 0 0 0 26 15v11H6V6h11l.117-.007A1 1 0 0 0 18 5m3 3.415-8 7.999V19h2.584l8.001-8zM22.415 7 24 5.415 26.585 8 25 9.585z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconNotePencil = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconNotePencil);
export default Memo;
